<template>
  <section
    class="credit js-color-change"
    data-logo-color="color"
    data-scroll-section
  >
    <div class="skew top"></div>
    <div class="l-container">
      <CSectionTitle>
        <template v-slot:titleEn>
          STAFF
        </template>
        <template v-slot:titleJa>
          スタッフ
        </template>
        <template v-slot:bg>
          <svg
            class="title-tri"
            width="656"
            height="490"
            viewBox="0 0 656 490"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#credit-title)">
              <path
                d="M632 18.0906L42.7261 173.21L26 459.091L632 18.0906Z"
                fill="white"
                opacity="0.1"
              />
            </g>
            <path
              d="M632 18.0906L42.7261 173.21L26 459.091L632 18.0906Z"
              fill="white"
            />
            <g filter="url(#credit-title)">
              <path
                d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
                fill="white"
                opacity="0.1"
              />
            </g>

            <path
              d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
              fill="white"
            />
            <filter id="credit-title">
              <feGaussianBlur
                in="SourceAlpha"
                stdDeviation="8"
              ></feGaussianBlur>
              <feOffset dx="8" dy="8" />
            </filter>
          </svg>
        </template>
      </CSectionTitle>

      <div class="credit-list-container main">
        <h3 class="credit-list-container__title"><span>KEY VISUAL</span></h3>
        <div class="main-credit-container">
          <div class="main-credit-item js-target">
            <div class="main-credit-item__photo">
              <h4
                data-scroll
                data-scroll-speed="0.2"
                class="main-credit-item__role"
              >
                <span class="main-credit-item__role-text">
                  Creative director
                </span>
              </h4>
              <div class="main-credit-item__photo-mask">
                <img
                  src="@/assets/hiro-sugiyama.jpg"
                  alt="ヒロ杉山のプロフィール写真"
                />
              </div>
              <svg
                class="main-credit-item__tri"
                width="276"
                height="180"
                viewBox="0 0 276 234"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  filter="url(#drop-shadow)"
                  d="M-0.000110388 164.458L236.677 173.679L275.548 68.9723L-0.000110388 164.458Z"
                  fill="white"
                  opacity="0.1"
                />
                <path
                  d="M-0.000110388 164.458L236.677 173.679L275.548 68.9723L-0.000110388 164.458Z"
                  fill="white"
                />
                <filter id="drop-shadow">
                  <feGaussianBlur
                    in="SourceAlpha"
                    stdDeviation="8"
                  ></feGaussianBlur>
                  <feOffset dx="-8" dy="-8" />
                </filter>
              </svg>
            </div>
            <p class="main-credit-item__name">ヒロ杉山</p>
            <p class="main-credit-item__name-en">Enlightenment</p>
            <p class="main-credit-item__desc">
              アーティスト、アートディレクター
              １９６２年東京生まれ。東洋美術学校卒業後、湯村輝彦氏に師事。その後フリーとなり、１９９７年グラフィックアートユニット,エンライトメントを結成。ファインアートの世界で国内外の展覧会で作品を発表する一方、グラフィックデザイン、広告など幅広いジャンルで独創的な作品を発表しつづけている。さらにPV制作やVJなどの映像分野での評価も非常に高く、三代目
              j soul
              brothers,EXILE,m-flo,安室奈美恵、BOA、少女時代などへライブ映像を提供している。
            </p>
          </div>
          <div class="main-credit-item js-target">
            <div class="main-credit-item__photo">
              <h4
                data-scroll
                data-scroll-speed="0.2"
                class="main-credit-item__role"
              >
                <span class="main-credit-item__role-text">
                  Photographer
                </span>
              </h4>
              <div class="main-credit-item__photo-mask">
                <img
                  src="@/assets/leslie-kee.jpg"
                  alt="Leslie Kee / レスリー・キーのプロフィール写真"
                />
              </div>
              <svg
                class="main-credit-item__tri"
                width="276"
                height="180"
                viewBox="0 0 276 234"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  filter="url(#drop-shadow)"
                  d="M-0.000110388 164.458L236.677 173.679L275.548 68.9723L-0.000110388 164.458Z"
                  fill="white"
                  opacity="0.1"
                />
                <path
                  d="M-0.000110388 164.458L236.677 173.679L275.548 68.9723L-0.000110388 164.458Z"
                  fill="white"
                />
                <filter id="drop-shadow">
                  <feGaussianBlur
                    in="SourceAlpha"
                    stdDeviation="8"
                  ></feGaussianBlur>
                  <feOffset dx="-8" dy="-8" />
                </filter>
              </svg>
            </div>
            <p class="main-credit-item__name">
              Leslie Kee / レスリー・キー
            </p>
            <p class="main-credit-item__name-en">SIGNO</p>
            <p class="main-credit-item__desc">
              シンガポール生まれ。
              フォトグラファーとしてアート、ファッション、広告の撮影、映像監督などを中心に世界各国で活動。彼が手掛ける写真とアートマガジンのシリーズ「SUPER」は、世界の企業やYOHJI
              YAMAMOTOをはじめとするファッションデザイナーなどと積極的にコラボレーションを仕掛ける。LGBTのポートレートを撮影するプロジェクト「OUT
              IN
              JAPAN」は、第19回文化庁メディア芸術祭エンタテインメント部門審査委員推薦作品に選出。
            </p>
          </div>
          <div class="main-credit-item js-target">
            <div class="main-credit-item__photo">
              <h4
                data-scroll
                data-scroll-speed="0.2"
                class="main-credit-item__role"
              >
                <span class="main-credit-item__role-text">
                  Stylist
                </span>
              </h4>
              <div class="main-credit-item__photo-mask">
                <img src="@/assets/takahashi.jpg" alt="高橋 毅" />
              </div>
              <svg
                class="main-credit-item__tri"
                width="276"
                height="180"
                viewBox="0 0 276 234"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  filter="url(#drop-shadow)"
                  d="M-0.000110388 164.458L236.677 173.679L275.548 68.9723L-0.000110388 164.458Z"
                  fill="white"
                  opacity="0.1"
                />
                <path
                  d="M-0.000110388 164.458L236.677 173.679L275.548 68.9723L-0.000110388 164.458Z"
                  fill="white"
                />
                <filter id="drop-shadow">
                  <feGaussianBlur
                    in="SourceAlpha"
                    stdDeviation="8"
                  ></feGaussianBlur>
                  <feOffset dx="-8" dy="-8" />
                </filter>
              </svg>
            </div>
            <p class="main-credit-item__name one-line">高橋 毅</p>
            <p class="main-credit-item__desc">
              武蔵野美術大学卒業。スタイリストとして雑誌、広告、俳優やアーティスト、ライブや舞台などを軸に活動しながら衣装デザインやその制作も行う。
            </p>
          </div>
        </div>
        <div class="credit-list">
          <div class="credit-row">
            <div class="credit-item js-target">
              <p class="credit-item__label">Designer</p>
              <p class="credit-item__name">
                中島 友太<span>（Enlightenment）</span>
              </p>
            </div>
            <div class="credit-item js-target">
              <p class="credit-item__label">Photo retouch</p>
              <p class="credit-item__name">FIGHT CLUB CO.,LTD.</p>
            </div>
            <div class="credit-item js-target">
              <p class="credit-item__label">Hair stylist</p>
              <p class="credit-item__name">
                高木琢也<span>（OCEAN TOKYO）</span
                ><span>（担当：水溜りボンド トミー、三科光平）</span>
              </p>
              <p class="credit-item__name">
                三科光平<span>（OCEAN TOKYO）</span
                ><span>（担当：水溜りボンド カンタ）</span>
              </p>
              <p class="credit-item__name">
                七五三掛慎二
                <span>（OCEAN TOKYO）</span>
                <span>（担当：ときど）</span>
              </p>
            </div>
            <div class="credit-item js-target">
              <p class="credit-item__label">Make up</p>
              <p class="credit-item__name">
                大剛 <span>（OCEAN TOKYO shibuya）</span>
              </p>
              <p class="credit-item__name">
                ERICO <span>（OCEAN TOKYO OVER）</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="credit-list-container">
        <h3 class="credit-list-container__title"><span>PRODUCT</span></h3>

        <div class="credit-list">
          <div class="credit-row">
            <div class="credit-item js-target">
              <p class="credit-item__label">Product design</p>
              <p class="credit-item__name">
                早川 和彦
              </p>
            </div>
            <div class="credit-item js-target">
              <p class="credit-item__label">Graphic design</p>
              <p class="credit-item__name">
                遠藤 幸
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="credit-list-container">
        <h3 class="credit-list-container__title"><span>WEB</span></h3>

        <div class="credit-list">
          <div class="credit-row">
            <div class="credit-item js-target">
              <p class="credit-item__label">Interview / Writer</p>
              <p class="credit-item__name">高木 望</p>
            </div>
            <div class="credit-item js-target">
              <p class="credit-item__label">Photographer（interview）</p>
              <p class="credit-item__name">
                折山 正樹
              </p>
            </div>
            <div class="credit-item js-target">
              <p class="credit-item__label">Movie</p>
              <p class="credit-item__name">
                葛生 龍太郎
              </p>
            </div>
          </div>
          <div class="credit-row">
            <div class="credit-item js-target">
              <p class="credit-item__label">Web design / Development</p>
              <p class="credit-item__name">大林 巧</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="organizer__container">
      <div class="organizer__row js-target">
        <div class="organizer__col role">
          OCEAN TOKYO CEO<br />OCEAN TOKYO 代表取締役
        </div>
        <div class="organizer__col name">
          髙木琢也
        </div>
      </div>

      <div class="organizer__row js-target">
        <div class="organizer__col role">
          Brand Producer<br />Product Development Manager
        </div>
        <div class="organizer__col name">
          三科 光平<span class="affiliation">(OCEAN TRICO 代表)</span>
        </div>
      </div>
      <div class="organizer__row js-target">
        <div class="organizer__col role">
          Business Development<br />Producer
        </div>
        <div class="organizer__col name">
          川上 鉄太郎<span class="affiliation"
            >(OCEAN TRICO 最高執行責任者 COO)</span
          >
        </div>
      </div>
      <div class="organizer__row js-target">
        <div class="organizer__col role">Project manager<br />Editor</div>
        <div class="organizer__col name">
          片山 昇平<span class="affiliation">(OCEAN TRICO)</span>
        </div>
      </div>

      <div class="organizer__row js-target">
        <div class="organizer__col role">Support</div>
        <div class="organizer__col">
          <div class="organizer__col name">
            設樂 めぐみ<span class="affiliation">(OCEAN TRICO)</span>
          </div>
          <div class="organizer__col name">
            木島 佑輔<span class="affiliation">(OCEAN TRICO)</span>
          </div>
        </div>
      </div>
    </div>

    <svg
      class="credit-tri"
      width="656"
      height="490"
      viewBox="0 0 656 490"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#credit-title)">
        <path
          d="M632 18.0906L42.7261 173.21L26 459.091L632 18.0906Z"
          fill="white"
          opacity="0.1"
        />
      </g>
      <path
        d="M632 18.0906L42.7261 173.21L26 459.091L632 18.0906Z"
        fill="white"
      />
      <g filter="url(#credit-title)">
        <path
          d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
          fill="white"
          opacity="0.1"
        />
      </g>

      <path
        d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
        fill="white"
      />
      <filter id="credit-title">
        <feGaussianBlur in="SourceAlpha" stdDeviation="8"></feGaussianBlur>
        <feOffset dx="8" dy="8" />
      </filter>
    </svg>
    <div class="skew bottom"></div>
  </section>
</template>

<script>
import 'lazysizes'

import CSectionTitle from '@/components/C-SectionTitle.vue'

export default {
  components: {
    CSectionTitle
  },
  mounted() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view')

          observer.unobserve(entry.target)
        }
      })
    })

    this.$el
      .querySelectorAll('.js-target')
      .forEach((el) => observer.observe(el))
  }
}
</script>

<style lang="scss" scoped>
.js-target {
  opacity: 0;
  transform: translate3d(0, 2rem, 0);
  transition: opacity 0.8s 0.15s $ease, transform 1.35s $ease;

  &.in-view {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.credit {
  position: relative;
  background: #fff;
  margin: 0 0 16rem;
  z-index: 0;
  .c-section-title {
    .title-tri {
      position: absolute;
      top: -17rem;
      left: -21rem;
      z-index: -9;
      transform: rotate(14deg);
      @media screen and (max-width: $breakpoint-mobile) {
        width: 50rem;
      }
    }
  }

  .l-container {
    position: relative;
    z-index: 1;
  }

  .credit-list-container {
    padding: 0 0 6rem;
    @media screen and (max-width: $breakpoint-mobile) {
      padding: 0 0 6.5rem;
    }

    &.main {
      @media screen and (max-width: $breakpoint-mobile) {
        padding: 4rem 0 6.5rem;
      }
    }

    &__title {
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--main-color);
      line-height: 1;
      font-size: 3.6rem;
      padding: 0 0 3rem;
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 2.4rem;
      }

      &:before,
      &:after {
        content: '';
        display: block;
        width: 1.5rem;
        height: 0.3rem;
        margin: 0 2rem;
        background: var(--main-color);
      }
    }
  }

  .main-credit-container {
    display: flex;
    padding: 3rem 0 4rem;

    @media screen and (max-width: $breakpoint-mobile) {
      flex-direction: column;
    }
    .main-credit-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 33.3333%;
      padding: 0 3rem;

      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        padding: 0 0 6rem;
      }

      &:last-child {
        @media screen and (max-width: $breakpoint-mobile) {
          padding: 0;
        }
      }
      &__photo {
        position: relative;
        width: 24rem;
        height: 24rem;
        background: #eee;
        z-index: -9;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 28rem;
          height: 28rem;
          z-index: 0;
        }
      }

      &__photo-mask {
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &__tri {
        width: 20rem;
        height: 20rem;
        position: absolute;
        bottom: -9rem;
        right: -4rem;
      }

      &__role {
        position: absolute;
        transform: skewY(-6deg);
        top: -1rem;
        left: -2rem;
      }

      &__role-text {
        position: relative;
        display: inline-block;
        color: #fff;
        line-height: 1;
        font-size: 1.3rem;
        padding: 1rem 1.6rem;
        font-weight: 600;
        transform: skewY(-6deg);
        text-indent: 1em;
        z-index: 0;

        &:after {
          position: absolute;
          top: 0;
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          background: var(--main-color);
          transform: skew(-30deg, 0deg);
          transform-origin: 0 0;
          z-index: -9;
        }
      }

      &__name {
        font-size: 2rem;
        font-weight: 800;
        margin: 3rem 0 0;
        line-height: 1;
        color: var(--main-color);

        &.one-line {
          margin: 3rem 0 2rem;
          @media screen and (max-width: $breakpoint-mobile) {
            margin: 3rem 0 0;
          }
        }
      }

      &__name-en {
        font-size: 1.4rem;
        margin: 1rem 0 0;
        line-height: 1;
        font-weight: 600;
        color: var(--main-color);
      }

      &__desc {
        font-size: 1.5rem;
        text-align: left;
        letter-spacing: 0;
        margin: 1.5rem 0 0;
        line-height: 1.6;
        font-weight: 500;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 1.3rem;
          line-height: 1.6;
        }
      }
    }
  }

  .credit-list {
    display: flex;
    flex-direction: column;
    padding: 0 3rem 0;

    @media screen and (max-width: $breakpoint-mobile) {
      flex-direction: column;
      padding: 0;
    }

    .credit-row {
      display: flex;
      justify-content: center;
      padding: 0;
      @media screen and (max-width: $breakpoint-mobile) {
        flex-direction: column;
      }

      &:not(:first-child) {
        padding: 3rem 0 0;
      }
      .credit-item {
        width: 25%;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 100%;

          & + .credit-item {
            padding: 3rem 0 0;
            @media screen and (max-width: $breakpoint-mobile) {
              padding: 2rem 0 0;
            }
          }
        }

        &__label {
          font-size: 1.5rem;
          font-weight: 800;
          letter-spacing: 0;
          color: var(--main-color);
          @media screen and (max-width: $breakpoint-mobile) {
            font-size: 1.2rem;
            margin: 0 0 1rem;
            line-height: 1;
          }
        }

        &__name {
          font-size: 2.2rem;
          font-weight: 600;
          color: var(--main-color);
          @media screen and (max-width: $breakpoint-mobile) {
            font-size: 1.8rem;
          }

          & + .credit-item__name {
            margin: 1rem 0 0;
          }

          span {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
    }
  }

  .organizer {
    &__container {
      padding: 8rem 0 0;
      border-top: 1px solid #e4051887;
      @media screen and (max-width: $breakpoint-mobile) {
        padding: 4rem 0 0;
      }
    }
    &__row {
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--main-color);
      @media screen and (max-width: $breakpoint-mobile) {
        flex-direction: column;
      }
      & + div {
        padding: 3rem 0 0;
      }
    }

    &__col {
      &.role {
        width: 35rem;
        text-align: right;
        font-size: 1.4rem;
        font-weight: 600;
        line-height: 1.2;
        padding: 0 1.5rem 0 0;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 1.4rem;
          text-align: center;
          padding: 0 0 0.5rem;
        }
      }

      &.name {
        display: flex;
        align-items: center;
        font-size: 2.6rem;
        font-weight: 800;
        width: 50rem;
        text-align: left;
        padding: 0 0 0 1.5rem;
        white-space: nowrap;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 2rem;
          text-align: center;
          width: 100%;
          text-align: center;
          flex-direction: column;
        }

        .affiliation {
          padding: 0 1.2rem;
          font-size: 1.8rem;
          @media screen and (max-width: $breakpoint-mobile) {
            font-size: 1.6rem;
          }
        }
      }
    }
  }

  .skew {
    position: relative;
    width: 100%;
    height: 20vw;
    transform: translate(0px, 5rem);
    z-index: 0;

    &.top {
      position: absolute;
      top: -9vw;
      @media screen and (max-width: $breakpoint-mobile) {
        top: -13vw;
      }
    }

    &.bottom {
      position: absolute;
      bottom: -4vw;
      z-index: -9;
      @media screen and (max-width: $breakpoint-mobile) {
        bottom: 0;
      }
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      transform: skew(0deg, -6deg);
      background: #fff;
    }
  }

  .credit-tri {
    position: absolute;
    left: -32rem;
    bottom: -50rem;
    z-index: -1;
    @media screen and (max-width: $breakpoint-mobile) {
      left: -5rem;
      bottom: -28rem;
      width: 30rem;
      height: 28rem;
    }
  }
}
</style>
